import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../auth/auth.service';
import { RoleEnum } from '../role/role.model';

@Injectable()
export class AuthGuardService implements CanActivate {

  constructor(private authService: AuthService, private router: Router) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (this.authService.isAuthenticated()) {
      const currentUser = this.authService.currentUserValue;
      //User role is authorize or not
      if (next.data['roles'] && next.data['roles'].indexOf(currentUser.role.toLowerCase()) === -1) {
        this.router.navigate(['login']);
        return false;
      }
      //User have permission for look up or not 
      if (currentUser.role.toLowerCase() === RoleEnum.clientUser && 'lookup' === next.routeConfig.path &&  !currentUser.pages.some(x=> x.route === next.routeConfig.path)) {
        this.router.navigate(['login']);
        return false;
      }
      // authorised so return true
      return true;
    }
    // navigate to login page
    this.router.navigate(['login']);
    // you can save redirect url so after authing we can move them back to the page they requested
    return false;
  }
}
